import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'tk-container',
	templateUrl: './container.component.html',
	styleUrls: ['./container.component.sass'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerComponent {}
